export { default } from "./Image";
